import React from 'react';
import { createRoot } from 'react-dom/client';
import './font/fonts.css';
import './i18n';
import i18n from './i18n';
import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error(i18n.t('errors:missingRoot'));
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
